import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Home, PlayCircle, Radio } from "lucide-react";

export default function NotFound() {
  useEffect(() => { document.title = "Page not found — B&B KIGALI FM"; }, []);
  return (
    <div className="px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto py-20 text-center" data-testid="not-found-page">
      <img src="/bb-logo.png" alt="B&B KIGALI FM" className="h-20 w-auto mx-auto mb-6 rounded-lg" />
      <div className="text-7xl font-black text-[#EF4444]">404</div>
      <h1 className="text-3xl sm:text-4xl font-extrabold text-white mt-2">Page not found</h1>
      <p className="text-slate-300 mt-3">The page you're looking for doesn't exist or has moved. Let's get you back in the game.</p>
      <div className="flex flex-wrap justify-center gap-3 mt-8">
        <Link to="/" data-testid="not-found-home" className="h-11 px-6 rounded-full bg-[#E11D2A] hover:bg-[#C8121F] text-white font-bold inline-flex items-center gap-2 transition-colors"><Home className="w-4 h-4" aria-hidden="true" /> Go home</Link>
        <Link to="/vod" data-testid="not-found-shows" className="h-11 px-6 rounded-full bg-white/5 border border-[#273042] text-white font-semibold inline-flex items-center gap-2 hover:bg-white/10 transition-colors"><PlayCircle className="w-4 h-4" aria-hidden="true" /> Browse shows</Link>
        <Link to="/radio" data-testid="not-found-radio" className="h-11 px-6 rounded-full bg-white/5 border border-[#273042] text-white font-semibold inline-flex items-center gap-2 hover:bg-white/10 transition-colors"><Radio className="w-4 h-4" aria-hidden="true" /> Live radio</Link>
      </div>
    </div>
  );
}
